export default "__VITE_ASSET__BYD7w5sE__"